<template>
  <crm-side-panel @handleClose="handleClose" :title="detail.name">
    <div class="side-panel-content">
      <div class="side-panel-buttons">
        <crm-button
          v-if="auth.govUpdate && auth.govUpdate.toggleStatus"
          :size="'mini'"
          :text="'编辑'"
          @click="toEdit()"
        >
        </crm-button>
        <crm-button
          v-if="auth.govDelete && auth.govDelete.toggleStatus"
          :size="'mini'"
          :buttonType="'danger'"
          :text="'删除'"
          @click="handleDelete()"
        >
        </crm-button>
      </div>
      <div class="side-panel-header">
        <!-- 头部信息 -->
        <div class="header-info">
          <div class="info-item">
            <p class="info-title">主要领导</p>
            <p class="info-detail">{{ detail.leader }}</p>
          </div>
          <div class="info-item">
            <p class="info-title">考察性质</p>
            <p class="info-detail">{{ detail.inspectQualityName }}</p>
          </div>
          <div class="info-item">
            <p class="info-title">考察类别</p>
            <p class="info-detail">{{ detail.inspectTypeName }}</p>
          </div>
          <div class="info-item">
            <p class="info-title">业务线</p>
            <p class="info-detail">{{ detail.lines4BusiName }}</p>
          </div>
        </div>
      </div>
      <div class="side-panel-tabs">
        <el-tabs v-model="activeTab" :stretch="false">
          <el-tab-pane label="详细信息" name="info">
            <pane-info :detail="detail"></pane-info>
          </el-tab-pane>
          <el-tab-pane label="考察人员" name="investigator">
            <pane-investigator
              :list="detail.personnelList"
              :isCurrentTab="activeTab === 'investigator'"
            ></pane-investigator>
          </el-tab-pane>
          <el-tab-pane
            label="项目"
            name="project"
            v-if="auth.govProjectTab && auth.govProjectTab.toggleStatus"
          >
            <pane-project
              :id="id"
              :isCurrentTab="activeTab === 'project'"
            ></pane-project>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <edit
      :visible="editVisible"
      :id="id"
      @close="editVisible = false"
      @success="handleEditSuccess()"
    >
    </edit>
  </crm-side-panel>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import CrmSidePanel from '~component/base/crmSidePanel.vue';
import CrmButton from '@/components/base/crmButton';
import Edit from './edit.vue';
import PaneInfo from './pane-info.vue';
import PaneInvestigator from './pane-investigator.vue';
import PaneProject from './pane-project.vue';

export default {
  props: {
    id: String,
    visible: Boolean,
  },
  components: {
    Edit,
    CrmSidePanel,
    CrmButton,
    PaneInfo,
    PaneInvestigator,
    PaneProject,
  },
  filters: {
    statusFilter(val) {
      const list = [
        {
          label: '待处理',
          value: 0,
        },
        {
          label: '跟进中',
          value: 1,
        },
        {
          label: '已转换',
          value: 2,
        },
        {
          label: '失效',
          value: 3,
        },
        {
          label: '其他',
          value: 4,
        },
      ];
      const target = list.find(item => item.value === val);
      return target ? target.label : '';
    },
  },
  data() {
    return {
      editVisible: false,
      activeTab: 'info',
    };
  },
  computed: {
    ...mapGetters({
      auth: 'authority/auth',
      detail: 'customer/governmentDetail',
    }),
  },
  watch: {
    visible(val) {
      if (val) this.getGovernmentDetail({ id: this.id });
      if (!val) this.activeTab = 'info';
    },
  },
  methods: {
    ...mapActions({
      deleteGovernmentCus: 'customer/deleteGovernmentCus',
      getGovernmentDetail: 'customer/getGovernmentDetail',
    }),
    handleEditSuccess() {
      this.getGovernmentDetail({ id: this.id });
      this.$emit('refresh');
    },
    toEdit() {
      this.editVisible = true;
    },
    handleDelete() {
      this.$confirm('此操作将永久删除该客户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.deleteGovernmentCus({ id: this.id })
            .then(() => {
              this.$message({
                type: 'success',
                message: '删除成功!',
              });
              this.$emit('close');
              this.$emit('refresh');
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
    handleClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="less">
.el-dropdown-menu .el-dropdown-menu__item {
  cursor: pointer;
}
</style>
